import * as z from "zod";

export const enableOmsOnCommentsoldIntegration = {
  name: "enableOmsOnCommentsoldIntegration" as const,
  input: z.object({ integrationId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
